module.exports = __webpack_public_path__ + "img/sceneca_9.d4af75ab.png";